var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createMemoryHistory } from 'history';
import { Router } from './Router';
import { defaultRouteReducer } from './Route';
import { createOrPassthroughObserver } from './Observable';
import { CurrentRouteObservable } from './CurrentRouteObservable';
import { createURLDescriptor } from './URLTools';
export function createMemoryNavigation(options) {
    return new MemoryNavigation(options);
}
var MemoryNavigation = /** @class */ (function () {
    function MemoryNavigation(options) {
        if (options.pages) {
            // if (process.env.NODE_ENV !== 'production') {
            //     console.warn(
            //         `Deprecation Warning: passing a "pages" option to "createMemoryNavigation()" will `+
            //         `no longer be supported from Navi 0.12. Use the "matcher" option instead.`
            //     )
            // }
            options.routes = options.pages;
        }
        var reducer = options.reducer || defaultRouteReducer;
        var url = options.url || (options.request && options.request.url);
        if (!url) {
            throw new Error("createMemoriNavigation() could not find a URL.");
        }
        this.history = createMemoryHistory({
            initialEntries: [createURLDescriptor(url).href],
        });
        this.options = options;
        this.router = new Router({
            context: options.context,
            routes: (this.options.routes || this.options.pages),
            basename: this.options.basename,
            reducer: reducer,
        });
        this.currentRouteObservable = new CurrentRouteObservable(this.history, this.router, reducer, options.request);
    }
    MemoryNavigation.prototype.dispose = function () {
        this.currentRouteObservable.dispose();
        delete this.currentRouteObservable;
        delete this.router;
        delete this.options;
    };
    MemoryNavigation.prototype.setContext = function (context) {
        this.currentRouteObservable.setContext(context);
    };
    MemoryNavigation.prototype.getCurrentValue = function () {
        return this.currentRouteObservable.getValue();
    };
    MemoryNavigation.prototype.getSteadyValue = function () {
        return this.currentRouteObservable.getSteadyRoute();
    };
    MemoryNavigation.prototype.steady = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSteadyValue()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * If you're using code splitting, you'll need to subscribe to changes to
     * the snapshot, as the route may change as new code chunks are received.
     */
    MemoryNavigation.prototype.subscribe = function (onNextOrObserver, onError, onComplete) {
        var navigationObserver = createOrPassthroughObserver(onNextOrObserver, onError, onComplete);
        return this.currentRouteObservable.subscribe(navigationObserver);
    };
    return MemoryNavigation;
}());
export { MemoryNavigation };
//# sourceMappingURL=MemoryNavigation.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/navi/dist/es/MemoryNavigation.js
// module id = 201
// module chunks = 0